import ServiceSlider from "../ServicesPage/ServiceSlider";
import WelfareBanner from "./WelfareBanner";
import WelfareTabs from "./WelfareTabs";

function WelfarePage() {
    return (
      <>
      <WelfareBanner/>
      <WelfareTabs />
      {/* <section className="latest-marine-info px-3" id="latest-marine-info">
        <div className="container max-1280">
          <ServiceSlider />
          
        </div>
      </section> */}
      
      </>
    )
  }
  
  export default WelfarePage;